import React from 'react';
import Table from '../../component/table/table'
import { BASE_END_POINT } from '../../urls'
import axios from 'axios'
import Button from '@material-ui/core/Button';
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader } from "mdbreact";
import './visiting.css'
import { message, TreeSelect, DatePicker, ConfigProvider } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import allStrings from '../../assets/strings'
import { connect } from 'react-redux';
import { withRouter, Redirect, NavLink } from 'react-router-dom'
import { ChangeLanguage } from '../../redux/actions/LanguageAction'
import { CSVLink } from "react-csv";
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import moment from 'moment'
import locale_ar from 'antd/lib/locale/ar_EG';
import locale_en from 'antd/lib/locale/en_GB';
import 'moment/locale/ar';
import PaginationButtons from '../../component/pagenation/pagenation';
const { TreeNode } = TreeSelect;
const { SHOW_PARENT } = TreeSelect;
const { RangePicker } = DatePicker;
let headers = [
  { label: "#", key: "id" },
  { label: "الموظف", key: "employee" },
  { label: "الاسم", key: "client" },
  { label: "رقم الهاتف", key: "phone" },
  { label: "المشروع", key: "project" },
  { label: "النوع", key: "type" },
  { label: "الحاله", key: "status" },
  { label: "التاريخ", key: "date" },
];

let csvData = [

];
class visiting extends React.Component {

  state = {
    visitings: [],
    visitings2: [],
    loading: true,
    refresh: false,
    page: 1,
    pages: 1,
    showFilter: false,
    search: this.props.location.state ? this.props.location.state.visitingsSearchData ? this.props.location.state.visitingsSearchData.search ? this.props.location.state.visitingsSearchData.search : null : null : null,
    count: 0,
    type: this.props.location.state ? this.props.location.state.visitingsSearchData ? this.props.location.state.visitingsSearchData.type ? this.props.location.state.visitingsSearchData.type : null : null : null,
    status: this.props.location.state ? this.props.location.state.visitingsSearchData ? this.props.location.state.visitingsSearchData.status ? this.props.location.state.visitingsSearchData.status : null : null : null,
    startDate: this.props.location.state ? this.props.location.state.visitingsSearchData ? this.props.location.state.visitingsSearchData.startDate ? this.props.location.state.visitingsSearchData.startDate : null : null : null,
    endDate: this.props.location.state ? this.props.location.state.visitingsSearchData ? this.props.location.state.visitingsSearchData.endDate ? this.props.location.state.visitingsSearchData.endDate : null : null : null,
    project: this.props.location.state ? this.props.location.state.visitingsSearchData ? this.props.location.state.visitingsSearchData.project ? this.props.location.state.visitingsSearchData.project : null : null : null,
    hasRequest: this.props.location.state ? this.props.location.state.visitingsSearchData ? this.props.location.state.visitingsSearchData.hasRequest ? this.props.location.state.visitingsSearchData.hasRequest : null : null : null,
    projects: [],
    isLate: null,
    csvData: [],
    isReady: false,
    buildCsv: false,
    users: [],
    employee: null,
    assignedToId: null,
    assignedTo: this.props.location.state ? this.props.location.state.data ? this.props.location.state.data.assignedTo : null : null,
    modalForAssigned: false,
    selectedRow: null,
  }

  constructor(props) {
    super(props)
    window.scrollTo(0, 0)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }

  componentDidMount() {
    let pageNum = this.state.page
    if (sessionStorage.getItem('pageName') === "VISITING") {
      pageNum = sessionStorage.getItem('pageNum');
      this.setState({ page: pageNum })
    }

    this.getVisitings(pageNum, false)
    this.getUserWithoutPagenation()
    this.getProjects()
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  getProjects = () => {
    axios.get(`${BASE_END_POINT}projects/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ projects: response.data.data })
      })
      .catch(error => {
        console.log("ALL projects ERROR")
        console.log(error.response)
      })
  }
  getUserWithoutPagenation = () => {
    axios.get(`${BASE_END_POINT}quickSearch/get?type=SUB-ADMIN`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en',
      },
    }).then(response => {
      console.log(response.data.data)
      this.setState({ users: response.data.data })
    })
      .catch(error => {
        console.log("ALL users ERROR")
        console.log(error.response)
      })
  }
  delete = (id) => {
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}visitings/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      },
    })
      .then(response => {
        console.log("visiting DELETED")
        l.then(() => message.success(allStrings.done, 2.5))
        this.getVisitings(this.state.page)
      })
      .catch(error => {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }
  getVisitings = (page, refresh, daily = false) => {
    this.setState({ loading: true })
    let { hasRequest, isLate, project, employee, type, status, search, startDate, endDate } = this.state
    if (daily) {
      startDate = moment().locale('en').format("YYYY-MM-DD")
      endDate = moment().locale('en').format("YYYY-MM-DD")
    }
    let url = `${BASE_END_POINT}visitings?page=${page}`
    if (refresh !== true) {
      let keysToFilter = { hasRequest, isLate, project, employee, type, status, search, startDate, endDate }
      Object.keys(keysToFilter).forEach(key => {
        if (keysToFilter[key] !== null) {
          url += `&${key}=${keysToFilter[key]}`;
        }
      });
      //search data 
      let visitingsSearchData = Object.fromEntries(
        Object.entries({
          hasRequest, isLate, project, employee, type, status, search, startDate, endDate
        }).filter(([_, value]) => value !== "" && value != null)
      );
      sessionStorage.setItem('visitingsSearchData', JSON.stringify(visitingsSearchData));
    } else {
      this.setState({ hasRequest: null, isLate: null, project: null, employee: null, type: null, status: null, search: null, startDate: null, endDate: null })
      sessionStorage.setItem('visitingsSearchData', JSON.stringify({}));
    }

    axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en',
      },
    })
      .then(response => {
        console.log("visiting   ", response.data)
        let data = response.data.data.map((item, index) => {
          return [
            item.id,
            item.employee ? item.employee.fullname.substr(0, 15) : "",
            item.fullname ? item.fullname : "",
            item.hasRequest ? { type: 'tag', value: allStrings.yes } : { type: 'tag', value: allStrings.no },
            item.project ? item.project.name : "",
            item.assignedTo ? item.assignedTo.fullname : 'لايوجد',
            // item.type==="DIRECT"?{type:'tag',value:allStrings.directVisit}:{type:'tag',value:allStrings.formInterestVisit},
            item.status === "PENDING" ? { type: 'tag', value: allStrings.pending } : item.status === "DONE" ? { type: 'tag', value: allStrings.done } : { type: 'tag', value: allStrings.canceled },
            item.createdAt ? this.props.isRTL ? moment(item.createdAt).locale('ar').format('ll') : moment(item.createdAt).locale('en').format('ll') : "",
            "action"
          ]
        })
        this.setState({
          loading: false,
          refresh: false,
          visitings: response.data.data,
          visitings2: data,
          page: response.data.page,
          count: response.data.totalCount,
          pages: response.data.pageCount,
        })
        sessionStorage.setItem('pageNum', page);
        sessionStorage.setItem('pageName', "VISITING");
      })
      .catch(error => {
        console.log("error   ", error.response)
        console.log("error2   ", error)
        this.setState({ loading: false, })
      })
  }
  getVisitingsWithoutPagenation = (refresh) => {
    let { hasRequest, isLate, project, employee, type, status, search, startDate, endDate } = this.state
    let url = `${BASE_END_POINT}visitings/withoutPagenation/get?all=true`
    if (refresh !== true) {
      let keysToFilter = { hasRequest, isLate, project, employee, type, status, search, startDate, endDate }
      Object.keys(keysToFilter).forEach(key => {
        if (keysToFilter[key] !== null) {
          url += `&${key}=${keysToFilter[key]}`;
        }
      });
    } else {
      this.setState({ hasRequest: null, isLate: null, project: null, employee: null, type: null, status: null, search: null, startDate: null, endDate: null })
    }
    axios.get(url, {
      headers: {
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en',
      }
    })
      .then(response => {

        csvData = response.data.data.map(item => {
          return {
            ...{ id: item.id },
            ...{ employee: item.employee.fullname ? item.employee.fullname : '' },
            ...{ fullname: item.fullname ? item.fullname : '' },
            ...{ phone: item.phone ? "\t" + item.phone : '' },
            ...{ project: item.project ? item.project.name : '' },
            ...{ type: item.type == "DIRECT" ? allStrings.directVisit : allStrings.formInterestVisit },
            ...{ status: item.status == "PENDING" ? allStrings.pending : this.state.status == "DONE" ? allStrings.done : this.state.status == "DEAL" ? allStrings.purchased : this.state.status == "RESCHEDULED" ? allStrings.rescheduled : allStrings.canceled },
            ...{ date: item.createdAt ? this.props.isRTL ? moment(item.createdAt).locale('ar').format('ll') : moment(item.createdAt).locale('en').format('ll') : '' },
          };
        });
        this.setState({ csvData: csvData, isReady: true })


      })
      .catch(error => {
        console.log("error   ", error.response)
        console.log("error2   ", error)
      })
  }
  addNewRecordButton = () => (
    <div style={{ width: '100%' }}>
      <NavLink to="AddVisiting">
        <Fab
          style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', float: 'left', margin: '50px 30px', width: '150px', height: '40px', borderRadius: '8px' }}
          letiant="extended"
          size="medium"
          color="primary"
          aria-label="add"
        >
          <AddIcon />{allStrings.addNewRecored}
        </Fab>
      </NavLink>
    </div>
  )
  assignedTo = () => {
    const { assignedToId } = this.state
    const idsArray = this.state.selectedRow.map(item => item.id);
    console.log("idsArray", idsArray)
    if (assignedToId != null) {
      let l = message.loading('Wait..', 2.5)
      axios.put(`${BASE_END_POINT}visitings/${idsArray}/assignTo/${assignedToId}`, {
        ids: idsArray
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.props.currentUser.token}`,
          'Accept-Language': this.props.isRTL ? 'ar' : 'en',
        },
      })
        .then(response => {
          console.log("interest assigned To")
          l.then(() => message.success(allStrings.done, 2.5))
          this.getVisitings(this.state.page, false)
          this.setState({ modalForAssigned: false, assignedToId: null, selectedRow: null })
        })
        .catch(error => {
          console.log(error.response)
          l.then(() => message.error(allStrings.error, 2.5))
        })
    }
  }
  submitHandlerAssigned = (event) => {
    event.preventDefault();
    event.target.className += " was-validated";
    this.assignedTo()
  };
  toggleForAssigned = (rowData) => {
    console.log("rowData", rowData)
    this.setState({
      selectedRow: Array.isArray(rowData) ? rowData : [rowData],
      modalForAssigned: !this.state.modalForAssigned,
    });
  };
  modalForAssigned = () => (
    <MDBModal isOpen={this.state.modalForAssigned} toggle={this.toggleForAssigned} size="lg">
      <MDBModalHeader toggle={this.toggleForAssigned} >{allStrings.completeData}</MDBModalHeader>
      <MDBModalBody>
        <MDBContainer>
          <MDBRow>
            <MDBCol md="12">
              <form style={{ paddingTop: '1rem' }}
                className="needs-validation"
                onSubmit={this.submitHandlerAssigned}
                noValidate
              >
                <div className="grey-text">
                  {this.state.selectedRow && this.state.selectedRow.length > 0 ? (
                    <div>
                      <label style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>
                        {this.state.selectedRow.map(row => `#${row ? row.id : ""}`).join(' - ')}
                      </label>
                    </div>
                  ) : null}

                  <MDBRow>
                    <MDBCol md="12">
                      <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.employee}</label>
                      <TreeSelect virtual={false}
                        showSearch={true}
                        style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                        treeCheckable={false}
                        treeNodeFilterProp="title"
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        placeholder={allStrings.employee}
                        onChange={(value) => {
                          console.log(value)
                          this.setState({ assignedToId: value });
                        }}

                      >
                        {this.state.users.map(val => (
                          <TreeNode value={val.id} title={val.fullname} key={val.id} />
                        ))}
                      </TreeSelect>
                    </MDBCol>
                  </MDBRow>
                </div>
                <div className="drawer-action-footer">
                  <MDBBtn type="button" className="btn-cancel" onClick={this.toggleForAssigned}>
                    إلغاء
                  </MDBBtn>
                  <MDBBtn type="submit" className="btn-submit">
                    {allStrings.send}
                  </MDBBtn>
                </div>
              </form>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </MDBModalBody>
    </MDBModal>
  );
  onChange = (date, dateString) => {
    if (this.props.isRTL) {
      this.setState({
        startDate: moment(dateString[0]).locale('en').format("YYYY-MM-DD"),
        endDate: moment(dateString[1]).locale('en').format("YYYY-MM-DD")
      })
    } else {
      this.setState({ to: moment(dateString).locale('en').format("YYYY/MM/DD") })
      this.setState({
        startDate: moment(dateString[0]).locale('en').format("YYYY-MM-DD"),
        endDate: moment(dateString[1]).locale('en').format("YYYY-MM-DD")
      })
      console.log(moment(dateString[0]).locale('en').format("YYYY-MM-DD"))

    }
    console.log(dateString);
  }

  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('VISITINGS')) return <Redirect to='/Home' />

    return (
      <div className="App">

        <MDBContainer>
          <MDBRow>
            {this.modalForAssigned()}
            <MDBCol md="12">
              <div className="screenTable">
                <Table
                  settings={
                    <div>

                      <i class="fab fa-searchengin searchIcon" onClick={() => this.setState({ showFilter: !this.state.showFilter })}></i>
                      <span
                        style={{ zIndex: '1', position: 'relative', padding: '4px', color: '#659FF1', fontSize: '25px', borderRadius: '50%', top: '4px', cursor: 'pointer' }}
                        onClick={() => { this.getVisitings(1, true); this.setState({ buildCsv: false }) }}
                        class="material-icons">
                        replay
                      </span>
                      {!this.state.buildCsv &&
                        <img crossorigin="anonymous" alt="" onClick={() => { this.setState({ buildCsv: true }); this.getVisitingsWithoutPagenation() }}
                          style={{ padding: '0px', position: 'relative', top: '-6px', marginLeft: '5px', cursor: 'pointer' }}
                          src={require('../../assets/images/buildCsv.png')} width="26"></img>
                      }{!this.state.isReady && this.state.buildCsv &&
                        <img crossorigin="anonymous" alt=""
                          style={{ padding: '0px', position: 'relative', top: '-5px', marginLeft: '-15px' }}
                          src={require('../../assets/images/loading.gif')} width="70"></img>
                      }{this.state.isReady && this.state.buildCsv &&
                        <CSVLink
                          data={this.state.csvData}
                          headers={headers}
                          filename={"visitings.csv"}
                          style={{ padding: '10px', position: 'relative', top: '-5px' }}
                        >
                          <img alt="" src={require('../../assets/images/export-csv.png')} width="28"></img>
                        </CSVLink>
                      }
                      <MDBBtn
                        color="primary"
                        style={{ display: 'inline-block', borderRadius: '30px', margin: '0 30px', padding: '10px', width: '120px', background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff' }}
                        rounded
                        className="btn-block z-depth-1a"
                        onClick={() => {
                          this.getVisitings(1, false, true);
                          this.setState({ buildCsv: false })
                        }}
                      >
                        {allStrings.dailyVisitings}
                      </MDBBtn>

                    </div>
                  }
                  filter={
                    <div>
                      <div className={this.state.showFilter ? 'showClass' : 'hideClass'}>
                        <MDBRow>
                          <MDBCol xl="4" lg="4" md="4" sm="12">
                            <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.status}</label>
                            <TreeSelect virtual={false}
                              showSearch={true}
                              value={this.state.status}
                              style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                              treeCheckable={false}
                              treeNodeFilterProp="title"
                              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                              placeholder={allStrings.status}
                              onChange={(value) => {
                                console.log(value)
                                this.setState({ status: value });
                              }}

                            >
                              <TreeNode value="PENDING" title={allStrings.pending} key="PENDING" />
                              <TreeNode value="RESCHEDULED" title={allStrings.rescheduled} key="RESCHEDULED" />
                              <TreeNode value="DONE" title={allStrings.done} key="DONE" />
                              <TreeNode value="DEAL" title={allStrings.purchased} key="DEAL" />
                              <TreeNode value="CANCELED" title={allStrings.canceled} key="CANCELED" />
                            </TreeSelect>
                          </MDBCol>
                          <MDBCol xl="4" lg="4" md="4" sm="12">
                            <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.type}</label>
                            <TreeSelect virtual={false}
                              showSearch={true}
                              value={this.state.type}
                              style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                              treeCheckable={false}
                              treeNodeFilterProp="title"
                              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                              placeholder={allStrings.type}
                              onChange={(value) => {
                                console.log(value)
                                this.setState({ type: value });
                              }}

                            >
                              <TreeNode value="DIRECT" title={allStrings.directVisit} key="DIRECT" />
                              <TreeNode value="FROM-INTEREST" title={allStrings.formInterestVisit} key="FROM-INTEREST" />

                            </TreeSelect>
                          </MDBCol>
                          <MDBCol xl="4" lg="4" md="4" sm="12">
                            <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.project}</label>
                            <TreeSelect virtual={false}
                              showSearch={true}
                              style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                              treeCheckable={false}
                              disabled={this.state.actionType === "VIEW" ? true : false}
                              treeNodeFilterProp="title"
                              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                              placeholder={allStrings.project}
                              value={this.state.project}
                              onChange={(value) => {
                                console.log(value)
                                this.setState({ project: value });
                              }}
                            >
                              {this.state.projects.map(val => (
                                <TreeNode value={val.id} title={this.props.isRTL ? val.name_ar : val.name_en} key={val.id} />
                              ))}
                            </TreeSelect>
                          </MDBCol>
                        </MDBRow>
                        <MDBRow>
                          <MDBCol xl="4" lg="4" md="4" sm="12">
                            <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.isLate}</label>
                            <TreeSelect virtual={false}
                              showSearch={true}
                              value={this.state.isLate}
                              style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                              treeCheckable={false}
                              treeNodeFilterProp="title"
                              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                              placeholder={allStrings.isLate}
                              onChange={(value) => {
                                console.log(value)
                                this.setState({ isLate: value });
                              }}

                            >
                              <TreeNode value={true} title={allStrings.yes} key={true} />
                              <TreeNode value={false} title={allStrings.no} key={false} />

                            </TreeSelect>
                          </MDBCol>
                          <MDBCol xl="4" lg="4" md="4" sm="12">
                            <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.hasRequest}</label>
                            <TreeSelect virtual={false}
                              showSearch={true}
                              value={this.state.hasRequest}
                              style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                              treeCheckable={false}
                              treeNodeFilterProp="title"
                              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                              placeholder={allStrings.hasRequest}
                              onChange={(value) => {
                                console.log(value)
                                this.setState({ hasRequest: value });
                              }}

                            >
                              <TreeNode value={true} title={allStrings.yes} key={true} />
                              <TreeNode value={false} title={allStrings.no} key={false} />

                            </TreeSelect>
                          </MDBCol>
                          <MDBCol xl="4" lg="4" md="4" sm="12">
                            <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.employee}</label>
                            <TreeSelect virtual={false}
                              showSearch={true}
                              style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                              treeCheckable={false}
                              treeNodeFilterProp="title"
                              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                              placeholder={allStrings.employee}
                              onChange={(value) => {
                                console.log(value)
                                this.setState({ employee: value });
                              }}

                            >
                              {this.state.users.map(val => (
                                <TreeNode value={val.id} title={val.fullname} key={val.id} />
                              ))}
                            </TreeSelect>
                          </MDBCol>
                        </MDBRow>
                        <MDBRow>
                          <MDBCol xl="6" lg="6" md="6" sm="12">
                            <label htmlFor="form605" className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.date}</label>
                            <ConfigProvider locale={this.props.isRTL ? locale_ar : locale_en}>
                              <RangePicker format={"YYYY-MM-DD"} placeholder={[allStrings.startDate, allStrings.endDate]} onChange={this.onChange} />
                            </ConfigProvider>
                          </MDBCol>
                          <MDBCol xl="6" lg="6" md="6" sm="12">
                            <div class="md-form">
                              <label htmlFor="form605" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.Search}</label>
                              <input style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', fontWeight: '300' }} type="text" id="form605" class="form-control"
                                placeholder={allStrings.Search}
                                onChange={(e) => {
                                  this.setState({ search: e.target.value })
                                }} />
                            </div>
                          </MDBCol>
                        </MDBRow>
                        <Button style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff', width: '100%', margin: '32px auto' }}
                          onClick={() => { this.getVisitings(1); this.setState({ buildCsv: false }) }}><SearchOutlined /> {allStrings.Search}</Button>

                      </div>
                    </div>
                  }
                  title={allStrings.visitings}
                  icon='assignment'
                  data={this.state.visitings}
                  data2={this.state.visitings2}
                  tableColumns={["#", allStrings.owner, allStrings.fullname, allStrings.hasRequest, allStrings.project, allStrings.employee, allStrings.status, allStrings.createdAt, allStrings.action]}
                  loading={this.state.loading}
                  deleteItem={(id) => { this.delete(id) }}
                  path='/VisitingInfo'
                  dataCount={this.state.count}
                  actionIndex={5}
                  noDelete={true}
                  enableAssigne={this.props.currentUser.user.type === "ADMIN" ? true : this.props.currentUser.user.isEmployee == false ? true : false}
                  assignedToModal={(rowData) => this.toggleForAssigned(rowData)}
                />
                <PaginationButtons
                  page={this.state.page}
                  pages={this.state.pages}
                  labels={allStrings}
                  onPageChange={(newPage) => {
                    this.getVisitings(newPage);
                    this.setState({ page: newPage });
                  }}
                />
                {this.addNewRecordButton()}

              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    )
  }
}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDispatchToProps = {
  ChangeLanguage
}

export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(visiting)
);

